import { groupBy, sortBy } from "lodash";

// eslint-disable-next-line no-unused-vars
export default function groupCategoriesByTenant(categories, tenantIds = [], _) {
    const groupedCategories = Object.fromEntries(
        Object.entries(groupBy(categories, "tenant_id"))
    );

    if (!tenantIds.length) {
        return Object.keys(groupedCategories).reduce((acc, key) => {
            return {
                ...acc,
                [key]: sortBy(groupedCategories[key]),
            };
        }, {});
    }

    return Object.keys(groupedCategories)
        .filter((key) => tenantIds.includes(key))
        .reduce((acc, key) => {
            return {
                ...acc,
                [key]: groupedCategories[key],
            };
        }, {});
}
